"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteTriggersComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const events_1 = require("@front/event/events");
const DEBUG = false; // Set to true to prevent hiding component content during development
//@ts-ignore                
let rwsTemplate = T.html `${(0, fast_element_1.when)(x => x.showSuggestions && x.triggerItems.length > 0, (0, fast_element_1.html) `
<div class="autocomplete-triggers-dropdown" @mouseleave="${x => x.selectedIndex = -1}">
    <div class="triggers-list">
        ${(0, fast_element_1.repeat)(x => x.triggerItems, (0, fast_element_1.html) `
                    <div 
                        class="trigger-item ${(x, c) => c.parent.isItemSelected(c.index) ? 'selected' : ''}"
                        @click="${(x, c) => c.parent.selectTrigger(x)}"
                    >
                <div class="trigger-header">
                    ${(0, fast_element_1.when)(x => x.type, (0, fast_element_1.html) `
                        ${(0, fast_element_1.when)(x => x.typeIcon, (0, fast_element_1.html) `<span class="trigger-type"><i class="${(x, c) => c.parent.iconClassPart}-${x => x.typeIcon}"></i></span>`)}
                    `)}
                    <span class="trigger-title">${(x, c) => x.title}</span>
                </div>
                ${(0, fast_element_1.when)(x => x.description, (0, fast_element_1.html) `
                    <div class="trigger-description">
                        ${(x, c) => x.description.substring(0, 100)}${(x, c) => x.description.length > 100 ? '...' : ''}
                    </div>
                `)}
            </div>
        `, { positioning: true })}
    </div>
    ${(0, fast_element_1.when)(x => x.triggerItems.length === 0 && !x.isSearching, (0, fast_element_1.html) `
        <div class="no-results">
            <span>${'autocomplete.triggers.noResults'.t()}</span>
        </div>
    `)}
</div>
`)}`;
require("./styles/layout.scss");
const styles = T.css `:host {
  position: absolute;
  width: var(--ac-width, 300px);
}

.autocomplete-triggers-dropdown {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  margin-bottom: 4px;
}
.autocomplete-triggers-dropdown .triggers-list .trigger-item {
  padding: 8px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.2s ease;
  background-color: transparent;
  min-width: 0;
  overflow: hidden;
}
.autocomplete-triggers-dropdown .triggers-list .trigger-item:hover {
  background-color: rgb(87.5546073352%, 71.1978055471%, 94.4884689627%);
  border-color: var(--primary_color, #7b1fa2);
  box-shadow: 0 2px 8px rgba(123, 31, 162, 0.2);
  position: relative;
}
.autocomplete-triggers-dropdown .triggers-list .trigger-item:hover::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background-color: var(--primary_color, #7b1fa2);
  border-radius: 0 2px 2px 0;
}
.autocomplete-triggers-dropdown .triggers-list .trigger-item:hover .trigger-title {
  color: var(--primary_color, #7b1fa2);
  font-weight: 600;
}
.autocomplete-triggers-dropdown .triggers-list .trigger-item.selected {
  background-color: rgb(87.5546073352%, 71.1978055471%, 94.4884689627%);
  border-color: var(--primary_color, #7b1fa2);
  box-shadow: 0 2px 8px rgba(123, 31, 162, 0.2);
  position: relative;
}
.autocomplete-triggers-dropdown .triggers-list .trigger-item.selected::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background-color: var(--primary_color, #7b1fa2);
  border-radius: 0 2px 2px 0;
}
.autocomplete-triggers-dropdown .triggers-list .trigger-item.selected .trigger-title {
  color: var(--primary_color, #7b1fa2);
  font-weight: 600;
}
.autocomplete-triggers-dropdown .triggers-list .trigger-item:last-child {
  border-bottom: none;
}
.autocomplete-triggers-dropdown .triggers-list .trigger-item .trigger-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 2px;
  min-width: 0;
}
.autocomplete-triggers-dropdown .triggers-list .trigger-item .trigger-header .trigger-type {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}
.autocomplete-triggers-dropdown .triggers-list .trigger-item .trigger-header .trigger-type.knowledge {
  background-color: rgb(87.5546073352%, 71.1978055471%, 94.4884689627%);
  color: var(--primary_color, #7b1fa2);
}
.autocomplete-triggers-dropdown .triggers-list .trigger-item .trigger-header .trigger-type.style {
  background-color: rgb(87.5546073352%, 71.1978055471%, 94.4884689627%);
  color: var(--primary_color, #7b1fa2);
}
.autocomplete-triggers-dropdown .triggers-list .trigger-item .trigger-header .trigger-title {
  font-weight: 500;
  color: #333;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.autocomplete-triggers-dropdown .triggers-list .trigger-item .trigger-description {
  font-size: 12px;
  color: #666;
  line-height: 1.3;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.autocomplete-triggers-dropdown .no-results {
  padding: 12px 16px;
  text-align: center;
  color: #999;
  font-size: 14px;
  font-style: italic;
}

autocomplete-triggers {
  position: relative;
  display: block;
}

autocomplete-triggers:not([show-suggestions]) {
  display: none;
}`;
const shadowOptions = { "mode": "open" };
let AutocompleteTriggersComponent = class AutocompleteTriggersComponent extends client_1.RWSViewComponent {
    constructor(apiService) {
        super();
        this.apiService = apiService;
        this.route = 'ai.triggerSearch'; // Default route, can be overridden
        this.queryParam = 'q'; // Query parameter name, default 'q'
        this.debounceMs = 300; // Debounce delay in milliseconds
        this.triggers = '/,#,@'; // Trigger characters separated by comma
        this.iconClassPart = 'simple-icon'; // Base class part for icons
        this.searchQuery = '';
        this.currentTrigger = '';
        this.triggerItems = [];
        this.isSearching = false;
        this.showSuggestions = false;
        this.selectedIndex = -1;
        this.selectedNotification = {};
        this.triggersHold = this.triggers.split(',');
        this.textInput = null;
        this.searchTimeout = null;
        this.isProcessingSelection = false; // Flag to prevent input handling during selection
        this.isPerformingSearch = false; // Flag to prevent multiple concurrent searches
        /**
         * Handle input events with debounced search
         */
        this.handleInput = (event) => {
            // Don't process input if we're in the middle of handling a selection
            if (this.isProcessingSelection) {
                return;
            }
            const target = event.target;
            const value = target.value;
            // Get current cursor position
            const cursorPos = target.selectionStart;
            // Extract the current word being typed
            const textBeforeCursor = value.substring(0, cursorPos);
            // Find the last trigger character and extract text after it
            let lastTriggerPos = -1;
            let foundTrigger = '';
            for (const trigger of this.triggersHold) {
                const pos = textBeforeCursor.lastIndexOf(trigger);
                if (pos > lastTriggerPos) {
                    lastTriggerPos = pos;
                    foundTrigger = trigger;
                }
            }
            // If we found a trigger character
            if (lastTriggerPos >= 0) {
                // Extract text after the trigger character
                const textAfterTrigger = textBeforeCursor.substring(lastTriggerPos + foundTrigger.length);
                // Check if there's no space after trigger (still typing the triggered word)
                if (!textAfterTrigger.includes(' ') && !textAfterTrigger.includes('\n')) {
                    this.currentTrigger = foundTrigger;
                    // Trigger search immediately when trigger is detected (no minChars requirement)
                    this.searchQuery = textAfterTrigger;
                    this.debouncedSearch();
                    return;
                }
            }
            // No valid trigger found, hide suggestions
            this.hideSuggestions();
        };
        /**
         * Handle keyboard navigation
         */
        this.handleKeydown = (event) => {
            if (!this.showSuggestions || this.triggerItems.length === 0)
                return;
            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    if (this.selectedIndex < 0) {
                        this.selectedIndex = 0; // Select first item if none selected
                    }
                    else {
                        this.selectedIndex = this.selectedIndex < this.triggerItems.length - 1
                            ? this.selectedIndex + 1
                            : 0; // Wrap to first item
                    }
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    if (this.selectedIndex < 0) {
                        this.selectedIndex = this.triggerItems.length - 1; // Select last item if none selected
                    }
                    else {
                        this.selectedIndex = this.selectedIndex > 0
                            ? this.selectedIndex - 1
                            : this.triggerItems.length - 1; // Wrap to last item
                    }
                    break;
                case 'Enter':
                    event.preventDefault();
                    if (this.selectedIndex >= 0 && this.selectedIndex < this.triggerItems.length) {
                        // First trigger the selection
                        this.selectTrigger(this.triggerItems[this.selectedIndex]);
                    }
                    break;
                case 'Escape':
                    event.preventDefault();
                    this.hideSuggestions();
                    break;
            }
        };
        /**
         * Handle blur events to hide suggestions
         */
        this.handleBlur = () => {
            // Delay hiding to allow clicking on suggestions
            setTimeout(() => {
                this.hideSuggestions();
            }, 200);
        };
    }
    connectedCallback() {
        super.connectedCallback();
        // Initialize state tracking
        this.isProcessingSelection = false;
        // In DEBUG mode, keep component visible
        if (DEBUG) {
            this.showSuggestions = true;
        }
        this.bindTextarea();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.unbindTextarea();
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
    }
    /**
     * Bind to a textarea element for autocomplete functionality
     */
    bindTextarea(textarea = null) {
        if (textarea instanceof HTMLTextAreaElement) {
            this.textInput = textarea;
            this.setupInputListeners();
        }
    }
    /**
     * Unbind from textarea
     */
    unbindTextarea() {
        if (this.textInput) {
            this.textInput.removeEventListener('input', this.handleInput);
            this.textInput.removeEventListener('keydown', this.handleKeydown);
            this.textInput.removeEventListener('blur', this.handleBlur);
            this.textInput = null;
        }
    }
    /**
     * Set up event listeners for the textarea
     */
    setupInputListeners() {
        if (!this.textInput)
            return;
        this.textInput.addEventListener('input', this.handleInput);
        this.textInput.addEventListener('keydown', this.handleKeydown);
        this.textInput.addEventListener('blur', this.handleBlur);
    }
    /**
     * Debounced search function
     */
    debouncedSearch() {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
        this.searchTimeout = setTimeout(() => {
            this.performSearch();
        }, this.debounceMs);
    }
    /**
     * Perform the actual search
     */
    async performSearch() {
        // Prevent concurrent searches
        if (this.isPerformingSearch) {
            return;
        }
        // Always perform search when triggered, even with empty query to show all entries
        this.isPerformingSearch = true;
        this.isSearching = true;
        try {
            const queryParams = {
                [this.queryParam]: this.searchQuery
            };
            // Add trigger as a query parameter if available
            if (this.currentTrigger) {
                queryParams.trigger = this.currentTrigger;
            }
            const response = await this.apiService.back.get(this.route, {
                queryParams
            });
            if (response && response.success && Array.isArray(response.data)) {
                this.triggerItems = response.data;
                this.selectedIndex = -1; // Start with no item selected
                const willShow = DEBUG || this.triggerItems.length > 0;
                this.showSuggestions = willShow;
            }
            else {
                this.triggerItems = [];
                const willShow = DEBUG;
                this.showSuggestions = willShow;
            }
        }
        catch (error) {
            console.error('Failed to search triggers:', error);
            this.triggerItems = [];
            const willShow = DEBUG;
            this.showSuggestions = willShow;
        }
        finally {
            this.isSearching = false;
            this.isPerformingSearch = false;
        }
    }
    /**
     * Select a trigger item
     */
    selectTrigger(trigger) {
        // Set flag to prevent input handling during selection processing
        this.isProcessingSelection = true;
        // Remove trigger and all text after it from textarea
        if (this.textInput && this.currentTrigger) {
            const value = this.textInput.value;
            const cursorPos = this.textInput.selectionStart;
            // Get text before cursor
            const textBeforeCursor = value.substring(0, cursorPos);
            // Find the position of the current trigger
            const triggerPos = textBeforeCursor.lastIndexOf(this.currentTrigger);
            if (triggerPos >= 0) {
                // Keep only the text before the trigger
                const newValue = value.substring(0, triggerPos);
                // Update textarea value
                this.textInput.value = newValue;
                // Set cursor position to the end of the remaining text
                this.textInput.selectionStart = newValue.length;
                this.textInput.selectionEnd = newValue.length;
                // Trigger input event to notify other components of the change
                this.textInput.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
        // Handle notifications if configured
        if (this.selectedNotification && Object.keys(this.selectedNotification).length > 0) {
            const message = this.selectedNotification[this.currentTrigger] || this.selectedNotification['default'];
            if (message && this.notifyService) {
                // Replace {name} with actual trigger title
                const notificationText = message.replace('{name}', trigger.title);
                this.notifyService.notify(notificationText, 'info');
            }
        }
        // Emit trigger selected event
        this.$emit(events_1.appEvents.triggerSelected, trigger);
        // Then hide suggestions
        this.hideSuggestions();
        this.isProcessingSelection = false;
        setTimeout(() => {
            this.emitOpenStateChangeEvent(false);
        }, 100);
    }
    /**
     * Hide suggestions dropdown
     */
    hideSuggestions() {
        if (!DEBUG) {
            this.showSuggestions = false;
            this.triggerItems = [];
        }
        this.selectedIndex = -1;
        this.searchQuery = '';
        this.currentTrigger = '';
    }
    /**
     * Check if item is selected
     */
    isItemSelected(index) {
        return this.selectedIndex === index;
    }
    showSuggestionsChanged(oldValue, newValue) {
        if (newValue !== undefined && oldValue !== newValue && !this.isProcessingSelection) {
            this.emitOpenStateChangeEvent(newValue);
        }
    }
    emitOpenStateChangeEvent(value) {
        this.$emit(events_1.appEvents.autocompleteStateChange, { isOpen: value });
    }
};
exports.AutocompleteTriggersComponent = AutocompleteTriggersComponent;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], AutocompleteTriggersComponent.prototype, "route", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], AutocompleteTriggersComponent.prototype, "queryParam", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Number)
], AutocompleteTriggersComponent.prototype, "debounceMs", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], AutocompleteTriggersComponent.prototype, "triggers", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], AutocompleteTriggersComponent.prototype, "iconClassPart", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], AutocompleteTriggersComponent.prototype, "searchQuery", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], AutocompleteTriggersComponent.prototype, "currentTrigger", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AutocompleteTriggersComponent.prototype, "triggerItems", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AutocompleteTriggersComponent.prototype, "isSearching", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AutocompleteTriggersComponent.prototype, "showSuggestions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], AutocompleteTriggersComponent.prototype, "selectedIndex", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], AutocompleteTriggersComponent.prototype, "selectedNotification", void 0);
exports.AutocompleteTriggersComponent = AutocompleteTriggersComponent = __decorate([
    (0, client_1.RWSView)('autocomplete-triggers', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(client_1.ApiService)),
    __metadata("design:paramtypes", [typeof (_a = typeof client_1.ApiServiceInstance !== "undefined" && client_1.ApiServiceInstance) === "function" ? _a : Object])
], AutocompleteTriggersComponent);
AutocompleteTriggersComponent.defineComponent();
